import _ from 'lodash'

import i18n from '@/i18n/i18n'
import SupplierDriverService from '@/services/admin/SupplierDriverService'
import { errorMessage } from '@/utilities/helpers.js'

import { SUPPLIER_DRIVER_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const allowedFilters = []
export const allowedIncludes = ''
export const allowedSorts = ''
export const allowedAppends = ''

export const namespaced = true

export const state = {
  drivers: []
}
export const mutations = {
  SET_SUPPLIER_DRIVERS(state, suppliers) {
    state.drivers = suppliers.data
  },
  ADD_SUPPLIER_DRIVER(state, supplier) {
    state.drivers.push(supplier)
  },
  UPDATE_SUPPLIER_DRIVER(state, supplierDriver) {
    let index = _.findIndex(state.drivers, function (s) {
      return s.id === supplierDriver.id
    })

    if (index !== -1) {
      state.drivers[index] = supplierDriver
    }
  },
  DELETE_SUPPLIER_DRIVER(state, deletedSupplier) {
    state.drivers = state.drivers.filter(supplier => {
      return supplier.id !== deletedSupplier.id
    })
  }
}

export const actions = {
  getSupplierDrivers({ commit, dispatch }, supplier) {
    return new Promise((resolve, reject) => {
      SupplierDriverService.getSupplierDrivers(supplier.id)
        .then(response => {
          commit('SET_SUPPLIER_DRIVERS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_DRIVER_ERROR_MESSAGES.getSupplierDriversError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createSupplierDriver({ dispatch, commit, state }, data) {
    return new Promise((resolve, reject) => {
      SupplierDriverService.createSupplierDriver(data.supplier_id, data)
        .then(response => {
          commit('ADD_SUPPLIER_DRIVER', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.supplier_drivers.supplier_driver')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_DRIVER_ERROR_MESSAGES.createSupplierDriverError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editSupplierDriver({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      SupplierDriverService.editSupplierDriver(data.supplier_id, data.id, data)
        .then(response => {
          commit('UPDATE_SUPPLIER_DRIVER', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.supplier_drivers.supplier_driver')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_DRIVER_ERROR_MESSAGES.editSupplierDriverError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteSupplierDriver({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      SupplierDriverService.deleteSupplierDriver(data.supplier_id, data.id)
        .then(response => {
          commit('DELETE_SUPPLIER_DRIVER', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.supplier_drivers.supplier_driver')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_DRIVER_ERROR_MESSAGES.deleteSupplierDriverError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getSupplierDriverInformationByTckn({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      SupplierDriverService.getSupplierDriverInformationByTckn(data)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSupplierDriverInformationByPhone({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      SupplierDriverService.getSupplierDriverInformationByPhone(data)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
